<template>
  <MobilePage>
    <!-- Same splash image as the desktop home page (GuestWelcome.vue) -->
    <img class="fixed inset-0 w-full h-full object-cover" src="@/assets/images/new-splash.jpg"/>
    <div class="fixed inset-0 bg-black/40"></div>

    <div class="relative p-4 space-y-6 text-white">
      <h1 class="text-2xl font-oxanium">Welcome to Aerocle</h1>

      <div>
        <div class="py-1 border-b border-white font-semibold tracking-wider">Announcements</div>
        <div v-if="displayedAnnouncements.length === 0" class="py-2 text-sm text-gray-200">No announcements</div>
        <div v-for="announcement in displayedAnnouncements" :key="announcement.id" class="py-2 border-b border-white/30">
          <div class="text-xs text-gray-200">{{ formatDate(announcement.announcement_date) }}</div>
          <div class="font-semibold">{{ announcement.title }}</div>
          <div v-if="announcement.body" class="text-sm">{{ announcement.body }}</div>
        </div>
      </div>
    </div>
  </MobilePage>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { formatDate } from '@/composables/formatDate';
import { getAnnouncements } from '@/services/Announcement';
import MobilePage from '@/components/mobile/base/MobilePage.vue';

const store = useStore()

const announcements = ref([])
const today = ref(new Date())

const displayedAnnouncements = computed(() => {
  return announcements.value.filter((announcement) => { return new Date(announcement.display_start_date) <= today.value}).filter((announcement) => { return new Date(announcement.display_end_date) >= today.value})
})

const hasInternalUserPermissions = computed(() => {
  let permissions = store.getters["auth/showUserPermissions"]
  return (
    permissions &&
    (
      permissions.isDev ||
      permissions.isManagement ||
      permissions.isSuperuser ||
      permissions.isAccountManager ||
      permissions.isAccountStaff ||
      permissions.isResearchLead ||
      permissions.isAdvancedResearch ||
      permissions.isResearch ||
      permissions.isHourly
    )
  )
})

async function loadAnnouncements() {
  if(hasInternalUserPermissions.value){
    const token = store.state.auth.token
    announcements.value = await getAnnouncements(token)
  }
}

loadAnnouncements()
</script>
